import { InternalAccount } from "@wingspanhq/wingspan-api-sdk";

export const selectorTaxWithholdingAccount = (
  internalAccount: InternalAccount
) =>
  internalAccount.type === "TaxWithholding" &&
  (internalAccount.status === "Active" || internalAccount.status === "Pending");
